import React from 'react';
import './Header.css';
import Clouds from './assets/Clouds.png';
import SaturdayApe from './assets/Logo.png';
import PowerdbyApe from './assets/PoweredByAPE.png';
import BabyApe from './assets/BabyApe.png';

function Header() {
  return (
    <div className='header_bg'>
      <div className="header_bg_container">
        <div className="clouds_animation">
          <img src={Clouds} alt="Moving Clouds" className="clouds_image" />
        </div>

        <div className="header_container">
          {/* Left side: Logo and powered by */}
          <div className="left_section">
            <a href='./'> <img src={SaturdayApe} alt="Saturday Apes Logo" className="logo" /></a>
           
            <img src={PowerdbyApe} alt="Powered by ApeChain" className="powered_by" />
          </div>

          {/* Right side: Links and Baby Ape */}
          <div className="right_section">
            <div className="nav_links">
            <a href="./TEAM" target="_blank" rel="noopener noreferrer" className="button-10">TEAM</a>
   <a href="./BOREDVILLE" target="_blank" rel="noopener noreferrer" className="button-10">BOREDVILLE</a>
              <a href="" className='button-10'>SOCIALS</a>
            </div>
            <img src={BabyApe} alt="Baby Ape" className="baby_ape" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
